<template>
  <div class="factory">
    <nav-header :navs="3" :navsitems="3"/>
    <div class="contents">
      <div class="in-banner">
        <img
            src="http://www.jiukaist.com/images/banner/5.png"
            width="100%"
            height="auto"
        />
      </div>
      <transition>
        <div class="pageBox waps">
          <el-tabs v-model="activeName">
            <el-tab-pane label="智慧城市" name="first">
              <div class="gsjs clearfix animation srcospcur" :loading="loading">
                <div class="Factorys-centers">
                  <div
                      class="Factorys-items"
                      v-for="(val, index) in smart_city.datalist"
                      :key="index"
                  >
                    <div class="factory_item" :title="val.title" @click="goPages(val.id)">
                      <div style="width: 100%;height:  100%;overflow: hidden">
                        <img v-if="val.image.indexOf('http') != -1"
                             :src="val.image"
                             style="width: 100%; height:  100%"
                        />
                        <img v-else
                             :src="`http://www.jiukaist.com${val.image}`"
                             style="width: 100%; height:  100%"
                        />
                      </div>
                      <div class="layui-elip text">{{ val.title}}</div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="el-pages">
                <el-pagination
                    background
                    @current-change="handleCurrentsmart_city"
                    :current-page="smart_city.page"
                    :page-size="smart_city.pagesize"
                    layout="total,prev,pager,next"
                    :total="smart_city.total"
                >
                </el-pagination>
              </div>
            </el-tab-pane>
            <el-tab-pane label="智慧养殖业" name="second">
              <div class="gsjs clearfix animation srcospcur" :loading="loading">
                <div class="Factorys-centers">
                  <div
                      class="Factorys-items"
                      v-for="(val, index) in smart_breed.datalist"
                      :key="index"
                  >
                    <div class="factory_item" :title="val.title" @click="goPages(val.id)">
                      <div style="width: 100%;height:  100%;overflow: hidden">
                        <img v-if="val.image.indexOf('http') != -1"
                             :src="val.image"
                             style="width: 100%; height: auto"
                             :preview-src-list="[val.image]"
                        />
                        <img v-else
                             :src="`http://www.jiukaist.com${val.image}`"
                             style="width: 100%; height: auto"
                             :preview-src-list="[val.image]"
                        />
                      </div>
                      <div class="layui-elip text">{{ val.title}}</div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="el-pages">
                <el-pagination
                    background
                    @current-change="handleCurrentsmart_breed"
                    :current-page="smart_breed.page"
                    :page-size="smart_breed.pagesize"
                    layout="total,prev,pager,next"
                    :total="smart_breed.total"
                >
                </el-pagination>
              </div>
            </el-tab-pane>
            <el-tab-pane label="智慧工业" name="third">
              <div class="gsjs clearfix animation srcospcur" :loading="loading">
                <div class="Factorys-centers">
                  <div
                      class="Factorys-items"
                      v-for="(val, index) in smart_industry.datalist"
                      :key="index"

                  >
                    <div class="factory_item" :title="val.title" @click="goPages(val.id)">
                      <div style="width: 100%;height:100%;overflow: hidden">
                        <img v-if="val.image.indexOf('http') != -1"
                             :src="val.image"
                             style="width: 100%; height: auto"
                             :preview-src-list="[val.image]"
                        />
                        <img v-else
                             :src="`http://www.jiukaist.com${val.image}`"
                             style="width: 100%; height: auto"
                             :preview-src-list="[val.image]"
                        />
                      </div>
                      <div class="layui-elip text">{{ val.title}}</div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="el-pages">
                <el-pagination
                    background
                    @current-change="handleCurrentsmart_industry"
                    :current-page="smart_industry.page"
                    :page-size="smart_industry.pagesize"
                    layout="total,prev,pager,next"
                    :total="smart_industry.total"
                >
                </el-pagination>
              </div>
            </el-tab-pane>
          </el-tabs>
        </div>
      </transition>
    </div>
    <nav-footer />
  </div>
</template>
<script>
import NavHeader from "@/components/NavHeaders.vue";
import NavFooter from "@/components/NavFooter.vue";
export default {
  name: "about",
  data() {
    return {
      loading:true,
      //智慧城市
      smart_city:{
        page:1,
        pagesize:12,
        total:0,
        type:'17',
        datalist:[]
      },
      //智慧养殖业
      smart_breed:{
        page:1,
        pagesize:12,
        total:0,
        type:'23',
        datalist:[]
      },
      //智慧工业
      smart_industry:{
        page:1,
        pagesize:12,
        total:0,
        type:'25',
        datalist:[]
      },
      activeName: 'first'
    };
  },
  components: {
    NavHeader,
    NavFooter,
  },
  mounted() {},
  created() {
    let self = this;
    document.documentElement.scrollTop='0px'
    self.getDataList(this.smart_city);
    self.getDataList(this.smart_breed);
    self.getDataList(this.smart_industry);
  },
  methods: {
    handleCurrentsmart_city(val) {
      this.smart_city.page = val
      let self = this;
      self.getDataList(this.smart_city);
    },
    handleCurrentsmart_breed(val) {
      this.smart_breed.page = val
      let self = this;
      self.getDataList(this.smart_breed);
    },
    handleCurrentsmart_industry(val) {
      this.smart_industry.page = val
      let self = this;
      self.getDataList(this.smart_industry);
    },
    getDataList(param) {
      this.$api.mall
          .getResolve({
            limit: param.pagesize,
            type:param.type,
            page: param.page,
          })
          .then((ress) => {
            let res = ress.data.data.data;
            param.datalist = res;
            param.total =  ress.data.data.total;
            this.loading = false
          });
    },
    goPages(id) {
      this.$router.push("/scheme/detail/" + id);
    },
  },
};
</script>
<style lang="scss" scoped>
.factory {
  width: 100%;
  overflow: hidden;
  margin: 0px auto;
  .v-enter {
    opacity: 0;
    transform: translateY(150px);
  }
  .v-enter-active {
    transition: all 1s ease;
  }
  .contents {
    width: 100%;
    overflow: hidden;
    margin: 0px auto;
    padding-top: 75px;
    min-width: 1350px;
    .el-pages{
      width: 100%;
      margin: 20px auto;
      overflow: hidden;
      text-align: center;
    }
    .waps {
      width: 90%;
      max-width: 1200px;
      overflow: hidden;
      margin: 0 auto;
    }
    .pageBox {
      padding: 60px 0;
      .Factorys-centers {
        width: 100%;
        margin: 0px auto;
        box-sizing: border-box;
        display: flex;
        flex-wrap: wrap;
        .Factorys-items {
          width: 31%;
          overflow: hidden;
          position: relative;
          height: 220px;
          margin-left: 25px;
          margin-bottom: 30px;
          box-sizing: border-box;
          box-shadow: 0 0 10px 0 #ddd;
          .factory_item{
            cursor: pointer;
            padding: 15px;
            width: calc(100% - 30px);
            height: calc(100% - 30px);
          }
          .text {
            position: absolute;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 1;
            overflow: hidden;
            bottom: 15px;
            width: calc(100% - 30px);
            left: 15px;
            height: 38px;
            color: #fff;
            text-align: center;
            background-color: rgba(0, 0, 0, 0.5);
            line-height: 38px;
          }
        }
      }
      .gsjs {
        transform: translate(0, 0px);
        opacity: 1;
        transition: 1.3s;
        -webkit-transition: 1.3s;
        .imgs {
          float: left;
          width: 420px;
          overflow: hidden;
        }
        .txts {
          float: right;
          width: calc(100% - 480px);
          line-height: 2em;
          font-family: 微软雅黑;
          font-size: 16px;
          color: #000000;
        }
        .txt {
          float: right;
          width: calc(100% - 480px);
          line-height: 1.5em;
        }
      }
      .pagetits {
        font-size: 26px;
        text-align: center;
        font-weight: bold;
        line-height: 1.2em;
        padding-bottom: 3%;
        color: #333333;
      }

      .pagetit {
        font-size: 26px;
        text-align: center;
        font-weight: bold;
        line-height: 1.2em;
        padding-bottom: 3.5%;
        color: #333333;
      }
    }
    .in-banner {
      width: 100%;
      overflow: hidden;
      margin: 0px auto;
    }
  }
  @media screen and(max-width:768px){
    .contents{
      padding-top: 60px!important;
      min-width: unset!important;
	  min-height: 600px;
    }
    .waps{
      width: calc(100% - 30px)!important;
      max-width: unset!important;
    }
    .pageBox{
      padding: 15px 0!important;
    }
    .Factorys-items{
      width: 47%!important;
      height: 140px!important;
      margin-left: 10px!important;
      margin-bottom:15px!important;
    }
    .factory_item{
      padding: 10px!important;
      width: calc(100% - 20px)!important;
      height: calc(100% - 20px)!important;
    }
    .text{
      width: calc(100% - 20px)!important;
      left: 10px!important;
    }
  }
}
</style>
